import { ActionButton } from '../../components';
import { CustomizedDxColumn } from './generateColumns';

export const setActionButton = (dxColumn: CustomizedDxColumn) => {
	dxColumn.cellComponent = ActionButton;
};
